
// import printJS from 'print-js'
import utils from '../utils'
import api from '@/lib/api'

function printBlobUrl (blobURL) {
  return new Promise((resolve) => {
    const iframe = document.createElement('iframe') // load content in an iframe to print later
    document.body.appendChild(iframe)
    iframe.style.display = 'none'
    iframe.src = blobURL
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus()
        iframe.contentWindow.print()
        setTimeout(() => {
          // 5分钟之后删除 iframe
          document.body.removeChild(iframe)
        }, 5 * 60 * 1000)
        resolve(true)
      }, 1)
    }
  })
}

export async function printDoc (url, params, printOptions, method) {
  let result = null
  if (method === 'get') {
    result = await api.bis.get(url, { responseType: 'blob' })
  } else {
    result = await api.bis.post(url, params, { responseType: 'blob' })
  }
  if (result.success) {
    var blob = new Blob([result.data], { type: 'application/pdf' }) // this make the magic
    const text = await blob.text()
    // if (blob.size <= 0) {
    //   return utils.perfectApiResult({
    //     success: false,
    //     message: '未加载到打印数据'
    //   })
    // }
    if (text.startsWith('{')) {
      const parse = JSON.parse(text)
      if (!parse.success) {
        return utils.perfectApiResult({
          success: false,
          message: parse.message
        })
      }
    }
    var blobURL = URL.createObjectURL(blob)
    const copies = printOptions?.copies ?? 1
    for (let index = 0; index < copies; index++) {
      await printBlobUrl(blobURL)
    }
    URL.revokeObjectURL(blobURL)
  }
  return result
}
